import React, { useContext, useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  Button,
  CircularProgress,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  styled,
} from "@mui/material";
import { MdCameraAlt } from "react-icons/md";
import { ImAttachment } from "react-icons/im";

import { DragNDrop } from "../../../components";
import {
  editarVisitSheet,
  getSale,
  getStatement,
  getVisitSheet,
} from "../../../services";
import { withRouter } from "../../../providers/withRouter";
import { UsuarioContext } from "../../../providers/userContext";
import { comprimirImagen, comprimirImagenOld, formatoFechas } from "../../../functions/funciones";
import { toast } from "react-toastify";
import CustomImageList from "../../../components/ImageList/CustomImageList";
import { verificarFecha } from "../../../functions/validator/formValidator";
import { useNavigate } from "react-router-dom";
import Portales from "../../../components/Comunidad/portales";

const ColorButton = styled(Button)(() => ({
  color: "white",
  backgroundColor: "#92004D",
  "&:hover": {
    backgroundColor: "#92004D",
  },
}));

const getTiposEdificio = (t) => [
  {
    value: "edificio",
    label: t('visitForm.buildingTypes.building'),
  },
  {
    value: "garaje",
    label: t('visitForm.buildingTypes.garage'),
  },
];

const SubQuestion = ({ question, checkBind, onChange, noTakes, t }) => {
  const [noTakesTrue, setNoTakesTrue] = useState(false);
  return (
    <Box className={`lae-flex lae-flex-column`} sx={{ gap: 0 }}>
      <Box>
        <Box sx={{ flex: 5 }}>
          <Typography>{question}</Typography>
        </Box>

        {!noTakesTrue && (
          <Box
            className="lae-flex lae-flex-row lae_alignItems-center lae-justifyContent-spaceBetween"
            sx={{ gap: 1, flex: 5 }}
          >
            <RadioGroup
              aria-labelledby="controlled"
              value={checkBind}
              sx={{ flexDirection: "row" }}
              onChange={(e) => {
                const checked = { target: { checked: e.target.value } };
                onChange(checked);
              }}
            >
              <FormControlLabel
                value="no"
                control={
                  <Radio
                    sx={{
                      color: "#92004D",
                      "&.Mui-checked": {
                        color: "#92004D",
                      },
                    }}
                  />
                }
                label={t('visitForm.radioOptions.no')}
              />
              <FormControlLabel
                value="si"
                control={
                  <Radio
                    sx={{
                      color: "#92004D",
                      "&.Mui-checked": {
                        color: "#92004D",
                      },
                    }}
                  />
                }
                label={t('visitForm.radioOptions.yes')}
              />
              {noTakes && (
                <FormControlLabel
                  value="np"
                  control={
                    <Radio
                      sx={{
                        color: "#92004D",
                        "&.Mui-checked": {
                          color: "#92004D",
                        },
                      }}
                    />
                  }
                  label={t('visitForm.radioOptions.notApplicable')}
                />
              )}
            </RadioGroup>
          </Box>
        )}
      </Box>
    </Box>
  );
};

function Comunidad(props) {
  const { t } = useTranslation(['properties', 'common']);
  let esPregunta15Si = false;
  let esPregunta5_1Si = false;
  let esPregunta5_2Si = false;
  const [formData, setFormData] = useState([]);

  const [formErrors, setFormErrors] = useState({});
  const user = useContext(UsuarioContext);
  const [additionalComments, setAdditionalComments] = useState("");

  const [imagenComunidad, setImagenComunidad] = useState(null);
  const [imagenUrl, setImagenUrl] = useState(null);

  const [imagenesComunidad, setImagenesComunidad] = useState([]);
  const [imagenesUrl, setImagenesUrl] = useState([]);
  const [imagenesNew, setImagenesNew] = useState([]);
  const [finca, setFinca] = useState({});
  const [recargar, setRecargar] = useState({});
  const [imagesToDelete, setImagesToDelete] = useState([]);
  const [numImages, setNumImages] = useState(0);
  const [statement, setStatement] = useState([]);
  const [procesandoImagenes, setProcesandoImagenes] = useState(false);
  const cameraInputRef = useRef(null);
  const fileInputRef = useRef(null);
  const cameraInputMultiRef = useRef(null);
  const fileInputMultiRef = useRef(null);

  const esMovil = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const esMovilUserAgent = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
    const esPantallaPequena = window.innerWidth <= 768 || window.innerHeight <= 600;
    const esTactil = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    
    // Ver si cumple al menos 2 condiciones
    const indicadores = [esMovilUserAgent, esPantallaPequena, esTactil].filter(Boolean).length;
    
    return indicadores >= 2;
  };

  useEffect(() => {
    fetchData();
  }, [recargar]);

  const navigate = useNavigate();
  const fetchData = async () => {
    const resSale = await getSale(props.params.id);
    const resStatement = await getStatement();
    const resVisitSheet = await getVisitSheet(
      resSale.detailsCae[0].visitSheet_id
    );
    const { data } = resVisitSheet;
    setStatement(resStatement);
    let nombre = "";

    if (data?.workcenter && Object.keys(data?.workcenter).length > 0) {
      nombre = data.workcenter?.razonSocial;
    } else {
      nombre = data.razonSocial;
    }

    const initialQuestions = resStatement.reduce((acc, s, index) => {
      let questionPrincipal = data.questions.find(
        (item) => item.statements_id == s.id
      )?.resp;
      let idRespuesta = data.questions.find(
        (item) => item.statements_id == s.id
      )?.id;
      acc[s.id] = {
        id: idRespuesta,
        statements_id: s.id,
        respuesta: questionPrincipal,
        subquestions:
          questionPrincipal === "si" || s.codigo === 1
            ? s?.subpreguntas?.reduce((subAcc, sub) => {
                subAcc[sub.id] = {
                  id: data?.questions?.find(
                    (item) => item?.statements_id == sub.id
                  )?.id,
                  statements_id: sub.id,
                  respuesta: data?.questions?.find(
                    (item) => item?.statements_id == sub.id
                  )?.resp,
                };
                return subAcc;
              }, {})
            : {},
      };
      return acc;
    }, {});

    setImagenUrl(`${process.env.REACT_APP_STORAGE_URL}${data.img}`);
    let ArrImagenes = [];

    data.images.forEach((imgURL, i) => {
      ArrImagenes.push({
        indice: i,
        id: imgURL.id,
        img: `${process.env.REACT_APP_STORAGE_URL}${imgURL.ruta}`,
      });
    });
    setImagenesUrl(ArrImagenes);
    setNumImages(ArrImagenes.length);

    setFormData((prev) => ({
      ...prev,
      visitSheet_id: data.id,
      sale_id: Number(props.params.id),
      aaff_id: data.aaff.id,
      IdComunidad: data.propertie?.id,
      statements_id: data.id,
      comunidad: data.propertie?.direccion,
      user_id: user.user_id,
      IdTecnicoPRL: user.id,
      tecnicoPRL: user.nombre + " " + user.apellidos,
      saleDate: formatoFechas(new Date()),
      comentario: data.comentario,
      tipo_edificio: data.tipo_edificio || "edificio",
      fechaVisita: formatoFechas(new Date(data.visitDate)),
      numeroPlantas: data.nPlantas,
      questions: initialQuestions,
      portales: data.portales,
      delPortales: data.delPortales
    }));
  };

  const comprimirConTimeout = async (file) => {

    const comprimirImagenOldConTimeout = (file) => {
      return new Promise((resolve, reject) => {
        let terminado = false;
        const timerOld = setTimeout(() => {
          if (!terminado) {
            terminado = true;
            //toast.error("La compresión de la imagen ha tardado demasiado (10s). Prueba con otra imagen.");
            reject(new Error("Timeout en compresión antigua"));
          }
        }, 10000);
        comprimirImagenOld(file)
          .then((blob) => {
            if (!terminado) {
              terminado = true;
              clearTimeout(timerOld);
              resolve(blob);
            }
          })
          .catch((err) => {
            terminado = true;
            clearTimeout(timerOld);
            toast.error(t('visitForm.toast.compressionError'));
            reject(err);
          });
      });
    };

    // Si el archivo es <= 50MB, intentamos primero con el método nuevo
    return new Promise(async (resolve, reject) => {
      let terminado = false;
      // Timeout para el método nuevo (20s)
      const timer = setTimeout(async () => {
        if (!terminado) {
          terminado = true;
          // Si el método nuevo tarda demasiado, intentamos con el antiguo (con timeout de 10s)
          try {
            const blobOld = await comprimirImagenOldConTimeout(file);
            resolve(blobOld);
          } catch (err) {
            reject(err);
          }
        }
      }, 20000);

      try {
        const blob = await comprimirImagen(file);
        if (!terminado) {
          terminado = true;
          clearTimeout(timer);
          resolve(blob);
        }
      } catch (err) {
        clearTimeout(timer);
        try {
          const blobOld = await comprimirImagenOldConTimeout(file);
          resolve(blobOld);
        } catch (errOld) {
          reject(errOld);
        }
      }
    });
  };

  const handleUploadImg = async (files) => {
    if (procesandoImagenes) return;
    if (!files || files.length === 0) return;
    
    const primeraImg = files[0];
 
    const extension = primeraImg.name.toLowerCase().split('.').pop();
    const extensionesValidas = ['jpg', 'jpeg', 'png', 'webp'];
    const tiposPermitidos = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/pjpeg'];
    
    const esValidoPorTipo = tiposPermitidos.includes(primeraImg.type);
    const esValidoPorExtension = extensionesValidas.includes(extension);
    
    if (!esValidoPorTipo && !esValidoPorExtension) {
      toast.error(`${t('visitForm.toast.invalidImageFormat')} (${primeraImg.type})`);
      return;
    }
    
    // Verificar tamaño máximo (50MB)
    if (primeraImg.size > 50 * 1024 * 1024) {
      toast.error(t('visitForm.toast.fileTooLarge'));
      return;
    }

    setProcesandoImagenes(true);

    try {
      //console.log(`Procesando imagen individual: ${firstImage.name} (${(firstImage.size / 1024 / 1024).toFixed(2)}MB)`);
      
      if (primeraImg.size <= 500 * 1024) {
        const imageUrl = URL.createObjectURL(primeraImg);
        setImagenComunidad(primeraImg);
        setImagenUrl(imageUrl);
      } else {
        const blob = await comprimirConTimeout(primeraImg);
        const nombreArchivo = primeraImg.name.split('.').slice(0, -1).join('.') + '.webp';
        const fileComprimido = new File([blob], nombreArchivo, { type: 'image/webp' });
        const imageUrl = URL.createObjectURL(fileComprimido);
        setImagenComunidad(fileComprimido);
        setImagenUrl(imageUrl);
      }
    } catch (err) {
      console.error(`Error procesando imagen individual ${primeraImg.name}:`, err);
      toast.error(`${t('visitForm.toast.processingError')} ${primeraImg.name}: ${err.message}`);
    } finally {
      setProcesandoImagenes(false);
    }
  };
  const handleUploadImgs = async (files) => {
    if (procesandoImagenes) return;
    if (!files || files.length === 0) return;
    
    const dispositivoMovil = esMovil();
    const fotosAProcesar = Array.from(files).slice(0, 20);
    
    if (files.length > 20) {
      return toast.error(t('visitForm.toast.maxImagesExceeded'));
    }

    const archivosValidos = fotosAProcesar.filter(file => {
      console.log(`Validando archivo: ${file.name}, tipo: ${file.type}, tamaño: ${(file.size / 1024 / 1024).toFixed(2)}MB`);
      
      const extension = file.name.toLowerCase().split('.').pop();
      const extensionesValidas = ['jpg', 'jpeg', 'png', 'webp'];
      const tiposPermitidos = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp', 'image/pjpeg'];
      
      const esValidoPorTipo = tiposPermitidos.includes(file.type);
      const esValidoPorExtension = extensionesValidas.includes(extension);
      
      if (!esValidoPorTipo && !esValidoPorExtension) {
        toast.error(`${file.name} ${t('visitForm.toast.invalidFile')} (${file.type})`);
        return false;
      }
      
      // Verificar tamaño máximo (50MB)
      if (file.size > 50 * 1024 * 1024) {
        toast.error(`${file.name} ${t('visitForm.toast.fileTooLarge')}`);
        return false;
      }
      
      return true;
    });

    if (archivosValidos.length === 0) {
      toast.error(t('visitForm.toast.noValidFiles'));
      return;
    }

    console.log(`Dispositivo: ${dispositivoMovil ? 'Móvil' : 'Ordenador'} - Archivos válidos: ${archivosValidos.length} de ${fotosAProcesar.length}`);

    setProcesandoImagenes(true);

    const ultimoId =
      imagenesUrl.length > 0
        ? imagenesUrl[imagenesUrl.length - 1].indice + 1
        : 0;

    const nuevasImagenes = [];
    let procesadasExitosamente = 0;
    let erroresEncontrados = 0;
    
    try {
      if (dispositivoMovil) {
        for (let i = 0; i < archivosValidos.length; i++) {
          const file = archivosValidos[i];
          try {
            if (file.size <= 500 * 1024) {
              nuevasImagenes.push(file);
              procesadasExitosamente++;
            } else {
              const blob = await comprimirConTimeout(file);
              const nombreArchivo = file.name.split('.').slice(0, -1).join('.') + '.webp';
              const fileComprimido = new File([blob], nombreArchivo, { type: 'image/webp' });
              nuevasImagenes.push(fileComprimido);
              procesadasExitosamente++;
              //console.log(`Imagen comprimida: ${nombreArchivo}`);
            }
          } catch (err) {
            erroresEncontrados++;
            console.error(`Error procesando ${file.name}:`, err);
            toast.error(`${t('visitForm.toast.processingError')} ${file.name}: ${err.message}`);
          }
        }
      } else {
        // Modo PC (en paralelo (más rápido))
        await Promise.all(
          archivosValidos.map(async (file) => {
            try {
              //console.log(`Procesando imagen: ${file.name} (${(file.size / 1024 / 1024).toFixed(2)}MB)`);
              if (file.size <= 500 * 1024) {
                nuevasImagenes.push(file);
                procesadasExitosamente++;
              } else {
                const blob = await comprimirConTimeout(file);
                const nombreArchivo = file.name.split('.').slice(0, -1).join('.') + '.webp';
                const fileComprimido = new File([blob], nombreArchivo, { type: 'image/webp' });
                nuevasImagenes.push(fileComprimido);
                procesadasExitosamente++;
              }
            } catch (err) {
              erroresEncontrados++;
              console.error(`Error procesando ${file.name}:`, err);
              toast.error(`${t('visitForm.toast.processingError')} ${file.name}: ${err.message}`);
            }
          })
        );
      }

      if (nuevasImagenes.length > 0) {
        setImagenesComunidad((prevImagenes) => [...prevImagenes, ...nuevasImagenes]);

        setImagenesUrl((prevUrls) => [
          ...prevUrls,
          ...nuevasImagenes.map((image, i) => {
            return {
              indice: ultimoId + i,
              id: ultimoId + i,
              img: URL.createObjectURL(image),
            };
          }),
        ]);
      }

      if (procesadasExitosamente > 0 && erroresEncontrados > 0) {
        toast.warn(`${procesadasExitosamente} ${t('visitForm.toast.imagesProcessed')}, ${erroresEncontrados} ${t('common:errors.errors')}`);
      } else if (procesadasExitosamente > 0) {
        toast.success(procesadasExitosamente > 1 ? `${procesadasExitosamente} ${t('visitForm.toast.imagesProcessed')}` : `1 ${t('visitForm.toast.imageProcessed')}`);
      } else if (erroresEncontrados > 0) {
        toast.error(t('visitForm.toast.imageProcessError'));
      }

    } catch (err) {
      console.error("Error general en handleUploadImgs:", err);
      toast.error(t('visitForm.toast.generalImageError'));
    } finally {
      setProcesandoImagenes(false);
    }
  };

  const validatePortales = (portales) => {
    if (!Array.isArray(portales)) return [];
    return portales.map((portal) => ({
      nombre: !portal.nombre?.trim(),
      numEscaleras: !portal.numEscaleras,
      numVecinos: !portal.numVecinos,
    }));
  };

  const validateForm = () => {
    const requiredFields = ["comentario","numeroPlantas", "fechaVisita", "questions"];
    const newErrors = {};

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = t('visitForm.validation.requiredField');
      }
    });

    const fechaCorrecta = verificarFecha(formData.fechaVisita);
    if (fechaCorrecta === false) {
      toast.error(t('visitForm.validation.invalidDateFuture'));
      newErrors.fechaVisita = t('visitForm.validation.invalidDateFuture');
    }

    // let portalesErrors = [];
    if (!props.params.idCentroTrabajo) {
      const portalesErrors = validatePortales(formData.portales || []);
      const portalesValidos = formData.portales?.filter(portal => 
        portal && !portal.del && portal.nombre?.trim() && portal.numEscaleras && portal.numVecinos
      ) || [];
      if (portalesValidos.length === 0) {
        newErrors.portales = t('visitForm.validation.requiredPortal');
        newErrors.portalesErrors = portalesErrors;
      } else if (portalesErrors.some(err => err.nombre || err.numEscaleras || err.numVecinos)) {
        newErrors.portales = t('visitForm.validation.portalErrors');
        newErrors.portalesErrors = portalesErrors;
      }
    }

    let algunaPreguntaPrincipalSinRespuesta = false;
    let algunaSubpreguntaSinRespuesta = false;

    const idsVisibles = new Set(
      (statement || [])
        .filter((s) => formData.tipo_edificio !== "garaje" || s.codigo === 4)
        .map((s) => String(s.id))
    );

    Object.keys(formData.questions || {}).forEach((questionId) => {
      if (!idsVisibles.has(String(questionId))) return;
      const question = formData.questions[questionId];
      if (!question.respuesta) {
        algunaPreguntaPrincipalSinRespuesta = true;
        newErrors.question = "faltan preguntas";
      }

      if (question.respuesta === "si") {
        const subquestions = formData.questions[questionId].subquestions || {};
        Object.keys(subquestions).forEach((subquestionId) => {
          const subquestion = subquestions[subquestionId];
          if (!subquestion.respuesta) {
            algunaSubpreguntaSinRespuesta = true;
            newErrors.subquestion = "faltan subpreguntas";
          }
        });
      }
    });

    if (algunaPreguntaPrincipalSinRespuesta || algunaSubpreguntaSinRespuesta) {
      toast.error(t('visitForm.validation.missingQuestions'));
    }
    setFormErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      toast.error(t('visitForm.validation.completeRequiredFields'));
      return;
    }

    let toastInfo = toast.info(t('visitForm.toast.savingData'), { autoClose: false });
    const idsVisibles = new Set(
      (statement || [])
        .filter((s) => formData.tipo_edificio !== "garaje" || s.codigo === 4)
        .map((s) => String(s.id))
    );
    const questionsFiltradas = Object.fromEntries(
      Object.entries(formData.questions || {}).filter(([qid]) => idsVisibles.has(String(qid)))
    );
    const datos = { ...formData, questions: questionsFiltradas };

    const res = await editarVisitSheet(
      datos,
      imagesToDelete,
      imagenesComunidad,
      imagenComunidad,
      props.params.nif
    );
    let fechCorrecta = verificarFecha(formData.fechaVisita);
    let errores = false;
    const requiredFields = ["comentario", "numeroPlantas", "fechaVisita"];
    const emptyFields = requiredFields.filter((key) => !formData[key]);
    if (emptyFields.length > 0) {
      toast.update(toastInfo, {
        render: t('visitForm.validation.fillAllFields'),
        type: toast.TYPE.ERROR,
        autoClose: true,
      });
    }
    if (fechCorrecta === false) {
      toast.error(t('visitForm.validation.invalidDateFuture'));
      errores = true;
    }

    if (!errores && res.status === 200) {
      toast.update(toastInfo, {
        render: t('visitForm.toast.dataSavedSuccess'),
        type: toast.TYPE.SUCCESS,
        autoClose: true,
      });
    } else if (res?.status === 403) {
      toast.update(toastInfo, {
        render: res.data.error.join(', '),
        type: toast.TYPE.ERROR,
        autoClose: true,
      });
    } else {
      toast.update(toastInfo, {
        render: t('visitForm.toast.dataSaveError'),
        type: toast.TYPE.ERROR,
        autoClose: true,
      });
    }
    
  };
  const addImagesToDelete = (image) => {
    // const nuevosImagenesUrl = imagenesUrl.filter((imagen) => imagen.indice !== image.indice);
    // // const indiceEnArchivos = imagenesComunidad.findIndex((archivo) => archivo.name === nuevosImagenesUrl[image.indice].img.split('/').pop());
    // const indiceEnArchivos = imagenesComunidad.find((archivo) => archivo.name === nuevosImagenesUrl[image.indice].img.split('/').pop());

    // if (indiceEnArchivos !== -1) {
    //   const nuevosArchivos = [...imagenesComunidad];
    //   nuevosArchivos.splice(indiceEnArchivos, 1);

    //   setImagenesComunidad(nuevosArchivos);
    // }

    const imgElement = document.querySelector(`.img-${image.indice}`);

    if (imgElement) {
      const nuevosDatos = imagenesUrl.filter(
        (item) => item.indice !== image.indice
      );
      const l = [...imagenesComunidad];

      l.splice(image.indice - numImages, 1);
      setImagenesComunidad(l);
      setImagenesUrl(nuevosDatos);
      setTimeout(() => {
        imgElement.remove();
        setImagesToDelete((prevs) => [
          ...prevs,
          { indice: image.indice, id: image.id, path: image.img },
        ]);
      }, 200);
    }
  };

  // if (!Array.isArray(formData) || formData.length == 0) {
  //   return <div>Loading...</div>; // Muestra un mensaje de carga o spinner
  // }

  return (
    <>
      <Box className="pageHeader" sx={{ backgroundColor: "#f6f7fb" }}>
        <Typography variant="h4" color="#212529" fontWeight={"bold"}>
          {t('documents.visitSheet')}
        </Typography>
      </Box>
      <Box className="pageContent comunidad-container centered" sx={{ p: 3 }}>
        <Typography
          variant="h6"
          color="#212529"
          fontWeight={"bold"}
          sx={{ mb: 4 }}
        >
          {t('details.communityData')}
        </Typography>
        {/* INFO_COMUNIDAD */}
        <Box className="lae-flex lae-flex-row lae-flex-between" sx={{ mb: 2 }}>
          <Box
            className="lae-flex lae-flex-column"
            sx={{
              flex: 1,
            }}
          >
            <Box className="lae-flex lae-flex-row">
              <TextField
                id="outlined-select-currency"
                select
                label={t('visitForm.buildingType')}
                value={formData.tipo_edificio || "edificio"}
                fullWidth
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    tipo_edificio: e.target.value,
                  }))
                }
              >
                {getTiposEdificio(t).map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                id="outlined-select-community"
                label={t('titleSingular')}
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={formData.comunidad}
                disabled
                // defaultValue={formData.comunidad}
              ></TextField>
            </Box>
            <Box className="lae-flex lae-flex-row">
              <TextField
                id="outlined-select-plantas-number"
                label={t('visitForm.numFloors')}
                fullWidth
                value={formData.numeroPlantas}
                InputLabelProps={{ shrink: true }}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    numeroPlantas: e.target.value,
                  }))
                }
                error={!!formErrors.numeroPlantas}
                helperText={formErrors.numeroPlantas}
              ></TextField>
              <TextField
                id="outlined-select-tecnico-prl"
                label={t('visitForm.technicianPrl')}
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={formData.tecnicoPRL}
                disabled
                style={{ webkitTextFillColor: "rgba(0, 0, 0, 0.8)" }}
                // defaultValue={formData.comunidad}
              ></TextField>
            </Box>

            <TextField
              id="outlined-select-date"
              type="date"
              label={t('visitForm.visitDate')}
              value={formData.fechaVisita}
              variant="outlined"
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  fechaVisita: e.target.value,
                }))
              }
              inputProps={{
                "aria-label": "controlled",
              }}
              InputLabelProps={{ shrink: true }}
            ></TextField>
            {!props.params.idCentroTrabajo &&            
              <Portales 
                formData={formData.portales} 
                setFormData={setFormData}
                error={{
                  portales: formErrors.portales,
                  portalesErrors: formErrors.portalesErrors
                }}
              />
            }
          </Box>
          <Box
            className="lae-flex lae-flex-column pos-relative"
            sx={{
              flex: 1,
            }}
          >
            <Box sx={{
              opacity: procesandoImagenes ? 0.5 : 1,
              pointerEvents: procesandoImagenes ? 'none' : 'auto',
              filter: procesandoImagenes ? 'grayscale(50%)' : 'none',
              transition: 'all 0.3s ease'
            }}>
              <DragNDrop
                onUpload={(files) => {
                  handleUploadImg(files);
                }}
                count={1}
                formats={["jpeg", "jpg", "png", "svg", "webp"]}
                label={
                  <Typography variant="caption">{t('visitForm.communityImage')}</Typography>
                }
                title={t('visitForm.dropOrSelectFile')}
                openDialogOnClick={false}
                disabled={procesandoImagenes}
              >
                <Box sx={{ display: 'flex', flexDirection: 'row', gap: 0 }}>
                  <input
                    ref={cameraInputRef}
                    type="file"
                    accept="image/*"
                    capture="environment"
                    style={{ display: 'none' }}
                    onChange={(e) => {
                      const files = [...e.target.files];
                      if (files.length > 0) handleUploadImg(files);
                      e.target.value = '';
                    }}
                  />
                  <input
                    ref={fileInputRef}
                    type="file"
                    accept="image/*"
                    style={{ display: 'none' }}
                    onChange={(e) => {
                      const files = [...e.target.files];
                      if (files.length > 0) handleUploadImg(files);
                      e.target.value = '';
                    }}
                  />
                  <Button
                    variant="outlined"
                    onClick={() => cameraInputRef.current?.click()}
                    disabled={procesandoImagenes}
                    sx={{
                      flex: 1,
                      minHeight: 80,
                      borderColor: '#c3c3c3',
                      borderStyle: 'dashed',
                      borderRadius: '4px 0 0 4px',
                      borderRight: 'none',
                      color: '#92004D',
                      backgroundColor: '#faf5f8',
                      textTransform: 'none',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 0.5,
                      fontSize: 13,
                      fontWeight: 500,
                      '&:hover': { backgroundColor: '#f0e0ea', borderColor: '#92004D', borderStyle: 'dashed', borderRight: 'none' },
                    }}
                  >
                    <MdCameraAlt size={28} />
                    {t('visitForm.takePhoto')}
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={() => fileInputRef.current?.click()}
                    disabled={procesandoImagenes}
                    sx={{
                      flex: 1,
                      minHeight: 80,
                      borderColor: '#c3c3c3',
                      borderStyle: 'dashed',
                      borderRadius: '0 4px 4px 0',
                      color: '#92004D',
                      backgroundColor: '#faf5f8',
                      textTransform: 'none',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 0.5,
                      fontSize: 13,
                      fontWeight: 500,
                      '&:hover': { backgroundColor: '#f0e0ea', borderColor: '#92004D', borderStyle: 'dashed' },
                    }}
                  >
                    <ImAttachment size={24} />
                    {t('visitForm.selectFile')}
                  </Button>
                </Box>
              </DragNDrop>
            </Box>
            {
              imagenUrl && (
                <img
                  src={imagenUrl}
                  alt={t('visitForm.mainImage')}
                  style={{
                    maxWidth: "100%",
                    height: "350px",
                    objectFit: "cover",
                  }}
                />
              )
              // <div style={{ paddingTop: '66.66%', backgroundImage: `url(${imagenUrl})`, backgroundPosition: 'center', backgroundSize: 'cover' }} ></div>
            }

            {procesandoImagenes && (
              <Box 
                sx={{ 
                  mb: 2, 
                  p: 2, 
                  backgroundColor: "#f0f8ff", 
                  border: "1px solid #92004D", 
                  borderRadius: "8px",
                  textAlign: "center"
                }}
              >
                <Typography 
                  variant="body1" 
                  sx={{ 
                    color: "#92004D", 
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 1
                  }}
                >
                  <CircularProgress size={20} sx={{ color: "#92004D" }} />
                  {t('visitForm.compressingImages')}
                </Typography>
              </Box>
            )}
            <Box sx={{
              opacity: procesandoImagenes ? 0.5 : 1,
              pointerEvents: procesandoImagenes ? 'none' : 'auto',
              filter: procesandoImagenes ? 'grayscale(50%)' : 'none',
              transition: 'all 0.3s ease'
            }}>
              <DragNDrop
                onUpload={(files) => handleUploadImgs(files)}
                count={20}
                formats={["jpeg", "jpg", "png", "svg", "webp"]}
                label={
                  <Typography variant="caption">{t('visitForm.riskImages')}</Typography>
                }
                title={t('visitForm.dropOrSelectImages')}
                openDialogOnClick={false}
                disabled={procesandoImagenes}
              >
                <Box sx={{ display: 'flex', flexDirection: 'row', gap: 0 }}>
                  <input
                    ref={cameraInputMultiRef}
                    type="file"
                    accept="image/*"
                    capture="environment"
                    style={{ display: 'none' }}
                    onChange={(e) => {
                      const files = [...e.target.files];
                      if (files.length > 0) handleUploadImgs(files);
                      e.target.value = '';
                    }}
                  />
                  <input
                    ref={fileInputMultiRef}
                    type="file"
                    accept="image/*"
                    multiple
                    style={{ display: 'none' }}
                    onChange={(e) => {
                      const files = [...e.target.files];
                      if (files.length > 0) handleUploadImgs(files);
                      e.target.value = '';
                    }}
                  />
                  <Button
                    variant="outlined"
                    onClick={() => cameraInputMultiRef.current?.click()}
                    disabled={procesandoImagenes}
                    sx={{
                      flex: 1,
                      minHeight: 80,
                      borderColor: '#c3c3c3',
                      borderStyle: 'dashed',
                      borderRadius: '4px 0 0 4px',
                      borderRight: 'none',
                      color: '#92004D',
                      backgroundColor: '#faf5f8',
                      textTransform: 'none',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 0.5,
                      fontSize: 13,
                      fontWeight: 500,
                      '&:hover': { backgroundColor: '#f0e0ea', borderColor: '#92004D', borderStyle: 'dashed', borderRight: 'none' },
                    }}
                  >
                    <MdCameraAlt size={28} />
                    {t('visitForm.takePhoto')}
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={() => fileInputMultiRef.current?.click()}
                    disabled={procesandoImagenes}
                    sx={{
                      flex: 1,
                      minHeight: 80,
                      borderColor: '#c3c3c3',
                      borderStyle: 'dashed',
                      borderRadius: '0 4px 4px 0',
                      color: '#92004D',
                      backgroundColor: '#faf5f8',
                      textTransform: 'none',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 0.5,
                      fontSize: 13,
                      fontWeight: 500,
                      '&:hover': { backgroundColor: '#f0e0ea', borderColor: '#92004D', borderStyle: 'dashed' },
                    }}
                  >
                    <ImAttachment size={24} />
                    {t('visitForm.selectFile')}
                  </Button>
                </Box>
              </DragNDrop>
            </Box>
            <Box>
              <CustomImageList
                imgs={imagenesUrl}
                addImagesToDelete={addImagesToDelete}
              />
              {/* {imagenesUrl.map((imageUrl, index) => (
                <img key={index} src={imageUrl} alt={`Imagen ${index + 1}`} style={{ maxWidth: '100%', width:'150px' }} />
              ))} */}
            </Box>
          </Box>
        </Box>
        {/* QUESTIONS */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <TextField
            id="outlined-multiline-static"
            label={t('visitForm.additionalComments')}
            multiline
            required
            rows={12}
            // placeholder="Escribe algo..."
            defaultValue={formData.comentario}
            InputLabelProps={{ shrink: true }}
            sx={{ width: "100%", alignSelf: "center", my: 2 }}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                comentario: e.target.value,
              }))
            }
            error={!!formErrors.comentario}
            helperText={formErrors.comentario}
          />
          <Typography
            variant="h6"
            color="#212529"
            fontWeight={"bold"}
            sx={{ mb: 4 }}
          >
            {t('visitForm.buildingRisks')}
          </Typography>
          {statement?.filter((s) => formData.tipo_edificio !== "garaje" || s.codigo === 4)?.map((s) => {
            return (
              <Box
                className="lae-flex lae-flex-row lae-flex-betweeen"
                key={s.id}
              >
                <Box
                  // className="lae-flex lae-flex-row"
                  sx={{ flex: 1, alignItems: "start" }}
                >
                  <SubQuestion
                    key={s.id}
                    question={`${s.codigo}.- ${s.pregunta}`}
                    checkBind={formData?.questions?.[s.id]?.respuesta}
                    t={t}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        questions: {
                          ...prev.questions,
                          [s.id]: {
                            ...prev.questions?.[s.id],
                            statements_id: s.id,
                            respuesta: e.target.checked,
                            subquestions: e.target.checked
                              ? (s.subpreguntas || []).reduce(
                                  (subAcc, subPreg) => {
                                    const prevId =
                                      prev.questions[s.id]?.subquestions?.[
                                        subPreg.id
                                      ]?.id || null;

                                    subAcc[subPreg.id] = {
                                      id: prevId, // <--- el id real de BD (o null si no existía)
                                      statements_id: subPreg.id,
                                      noTakes: subPreg.noProcede ? true : false,
                                      respuesta: undefined,
                                    };
                                    return subAcc;
                                  },
                                  {}
                                )
                              : {},
                          },
                        },
                      }))
                    }
                    noTakes={s.noProcede ? true : false}
                  />
                </Box>
                {(formData?.questions[s.id]?.respuesta === "si" ||
                  s.codigo === 1) && (
                  <Box
                    className="lae-flex lae-flex-column"
                    sx={{
                      flex: 1,
                      p: 2,
                      boxShadow: "0px 0.1px 3px rgba(0, 0, 0, 0.1)",
                      backgroundColor: "rgb(229 216 216 / 10%)",
                      borderRadius: "10px",
                    }}
                  >
                    {s.subpreguntas.map((p) => {
                      if (
                        formData?.questions[s.id]?.subquestions[p.id]
                          ?.statements_id == 15 &&
                        formData?.questions[s.id]?.subquestions[p.id]
                          ?.respuesta == "si"
                      ) {
                        esPregunta15Si = true;
                      }
                      if (
                        formData?.questions[s.id]?.subquestions[p.id]
                          ?.statements_id == 15 &&
                        formData?.questions[s.id]?.subquestions[p.id]
                          ?.respuesta == "no"
                      ) {
                        esPregunta15Si = false;
                      }
                      if (
                        esPregunta15Si &&
                        (formData?.questions[s.id]?.subquestions[p.id]
                          ?.statements_id == 16 ||
                          formData?.questions[s.id]?.subquestions[p.id]
                            ?.statements_id == 17 ||
                          formData?.questions[s.id]?.subquestions[p.id]
                            ?.statements_id == 18)
                      ) {
                        formData.questions[s.id].subquestions[p.id].respuesta =
                          "null";
                        return null;
                      }
                      // si la pregunta 5_1 es si que muestre la pregunta 5_2 y la 5_3 no
                      if (
                        formData?.questions[s.id]?.subquestions[p.id]
                          ?.statements_id == 43 &&
                        (formData?.questions[s.id]?.subquestions[p.id]
                          ?.respuesta == "no" ||
                          formData?.questions[s.id]?.subquestions[p.id]
                            ?.respuesta === undefined)
                      ) {
                        esPregunta5_1Si = true;
                      }
                      if (
                        formData?.questions[s.id]?.subquestions[p.id]
                          ?.statements_id == 43 &&
                        formData?.questions[s.id]?.subquestions[p.id]
                          ?.respuesta == "si"
                      ) {
                        esPregunta5_1Si = false;
                      }
                      if (
                        esPregunta5_1Si &&
                        (formData?.questions[s.id]?.subquestions[p.id]
                          ?.statements_id == 44 ||
                          formData?.questions[s.id]?.subquestions[p.id]
                            ?.statements_id == 45)
                      ) {
                        formData.questions[s.id].subquestions[p.id].respuesta =
                          "null";
                        return null;
                      }
                      // si la pregunta 5_2 es si que muestre la pregunta 5_3
                      if (
                        formData?.questions[s.id]?.subquestions[p.id]
                          ?.statements_id == 44 &&
                        (formData?.questions[s.id]?.subquestions[p.id]
                          ?.respuesta == "no" ||
                          formData?.questions[s.id]?.subquestions[p.id]
                            ?.respuesta === undefined ||
                          formData?.questions[s.id]?.subquestions[p.id]
                            ?.respuesta === "null")
                      ) {
                        esPregunta5_2Si = true;
                      }
                      if (
                        formData?.questions[s.id]?.subquestions[p.id]
                          ?.statements_id == 44 &&
                        formData?.questions[s.id]?.subquestions[p.id]
                          ?.respuesta == "si"
                      ) {
                        esPregunta5_2Si = false;
                      }
                      if (
                        !esPregunta5_1Si &&
                        esPregunta5_2Si &&
                        formData?.questions[s.id]?.subquestions[p.id]
                          ?.statements_id == 45
                      ) {
                        formData.questions[s.id].subquestions[p.id].respuesta =
                          "null";
                        return null;
                      }
                      return (
                        <SubQuestion
                          question={`${p.codigo}.${p.subcodigo}.- ${p.pregunta}`}
                          checkBind={
                            formData?.questions[s.id]?.subquestions[p.id]
                              ?.respuesta
                          }
                          noTakes={p.noProcede ? true : false}
                          t={t}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              ...prev,
                              questions: {
                                ...prev?.questions,
                                [s.id]: {
                                  ...prev?.questions?.[s.id],
                                  subquestions: {
                                    ...prev?.questions?.[s.id]?.subquestions,
                                    [p.id]: {
                                      ...prev?.questions?.[s.id]
                                        ?.subquestions?.[p.id],
                                      statements_id: p.id,
                                      noTakes: p.noProcede ? true : false,
                                      respuesta: e.target.checked,
                                    },
                                  },
                                },
                              },
                            }))
                          }
                        />
                      );
                    })}
                  </Box>
                )}
              </Box>
            );
          })}
          <ColorButton
            sx={{ alignSelf: "center", width: "80%" }}
            onClick={() => handleSubmit()}
            disabled={procesandoImagenes}
          >
            {procesandoImagenes ? (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <CircularProgress size={24} sx={{ color: "#92004d" }} />
                {t('visitForm.processingImages')}
              </Box>
            ) : (
              t('visitForm.saveAndSend')
            )}
          </ColorButton>
        </Box>
      </Box>
      <style jsx>{`
        .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input.Mui-disabled {
          -webkit-text-fill-color: rgba(0, 0, 0, 0.8);
        }
      `}</style>
    </>
  );
}

export default withRouter(Comunidad);
